import { createCrudPage } from './factories/crud-page.js';

const basePath = '/expo-translations';

export default createCrudPage({
  title: 'Expo Translations',
  basePath,
  columns: [
    { key: 'expo_type', label: 'Type', sortable: true },
    { key: 'expo_title', label: 'Expo', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'city', label: 'City', sortable: true },
    { key: 'start_date', label: 'Start', sortable: true },
    { key: 'finish_date', label: 'Finish', sortable: true },
    { key: 'enabled', label: 'Enabled', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options',
      placeholder: 'Select country', required: true },
    { key: 'expo_id', label: 'Expo', type: 'async-select',
      optionsUrl: '/expos/options',
      dependsOn: ['country'],
      valuesParams: { country: 'country' },
      visible: (v) => !!v.country,
      placeholder: 'Select expo title' },
    { key: 'title', label: 'Title', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'city', label: 'City', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'location_name', label: 'Location name', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'address', label: 'Street address', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'phone', label: 'Phone', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'email', label: 'Email', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'contact_person', label: 'Contact person', type: 'text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'description', label: 'Description', type: 'rich-text',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
    { key: 'enabled', label: 'Enabled', type: 'yesno', defaultValue: '1',
      dependsOn: ['expo_id'],
      visible: (v) => !!v.expo_id },
  ],
  filters: [
    { key: 'country', label: 'Country', type: 'select',
      optionsUrl: '/countries/options' },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'activate', label: 'Activate', icon: 'activate',
      confirm: 'Are you sure you want to activate this translation?',
      visible: (row) => row.enabled == 0 },
    { key: 'deactivate', label: 'Deactivate', icon: 'deactivate',
      confirm: 'Are you sure you want to deactivate this translation?',
      visible: (row) => row.enabled == 1 },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  customActions: (ctx) => ({
    activate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { enabled: 1 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    deactivate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { enabled: 0 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
  }),
  defaultSort: { field: 'expo_title', dir: 'asc' },
});
